import styled from 'styled-components';
import { Container, ContainerProps } from '~/components/layout';

export const PreviewContainer = styled(Container)`
  align-items: center;
  background-color: ${props => props.theme.colors.background.secondary};
  border-radius: ${props => props.theme.borderRadii.large};
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  min-height: 92px;
  padding: 16px 24px;

  && * {
    flex-shrink: 0;
  }

  .image-preview-details {
    flex: 1 1 auto;
    min-width: 0;
  }

  .image-preview-details,
  .image-preview-details * {
    overflow-wrap: anywhere;
    white-space: normal;
  }

  .file-name {
    font-size: 12px;
    padding-top: 8px;
    max-width: 225px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

export const Dropzone = styled(PreviewContainer)`
  cursor: pointer;
  margin-top: 16px;
  margin-bottom: 16px;
  border: ${props => `1px dashed ${props.theme.colors.background.controls}`};
  background-color: unset;
  justify-content: center;
`;

export const DropzoneCt = styled.div`
  .dropzone-drag {
    font-size: 12px;
    text-align: center;
    padding-top: 24px;
  }
  .dropzone-format {
    font-size: 12px;
    text-align: center;
  }
`;

export const ImageContainer = styled(Container)<ContainerProps & { backgroundImage: string }>`
  background-image: url(${props => props.backgroundImage});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: ${props => props.theme.borderRadii.small};
  display: inline;
  height: 40px;
  overflow: hidden;
  width: 40px;
`;

export const DeleteButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  margin-left: auto;
`;

export const PdfImageContainer = styled(Container)<ContainerProps>`
  margin-right: 16px;
  display: inline;
  height: 40px;
  overflow: hidden;
  width: 40px;
`;
